/** Line icons (1.7 stroke, 24 grid) shared by the rail, buttons and locks. Paths transcribe the mockup set. */
import type { ReactNode } from "react";

const PATHS = {
  cockpit: <><path d="M4 14a8 8 0 1 1 16 0" /><path d="M12 14l4-4" /><path d="M4 18h16" /></>,
  financials: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h5" /></>,
  decide: <><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></>,
  outlook: <><path d="M3 17l5-5 4 3 4-6" /><path d="M16 9l5-3" strokeDasharray="2 2.5" /><path d="M4 20h16" /></>,
  results: <path d="M5 20V10M12 20V4M19 20v-7" />,
  coach: <><path d="M12 3l1.8 4.6L18 9.4l-4.2 1.8L12 16l-1.8-4.8L6 9.4l4.2-1.8z" /><path d="M18 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z" /></>,
  spark: <path d="M12 3l1.8 4.6L18 9.4l-4.2 1.8L12 16l-1.8-4.8L6 9.4l4.2-1.8z" />,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>,
  warn: <><path d="M12 3l10 18H2z" /><path d="M12 10v5M12 18h0" /></>,
  check: <path d="M5 12l5 5 9-10" />,
  quote: <path d="M4 5h16v11H9l-5 4z" />,
  board: <><circle cx="9" cy="8" r="3.5" /><path d="M3 20c.8-3.5 3.2-5 6-5s5.2 1.5 6 5" /><circle cx="17" cy="9" r="2.5" /><path d="M16 15c2.4.2 4.2 1.7 5 5" /></>,
  studio: <><rect x="3" y="5" width="18" height="12" rx="1.5" /><path d="M7 13l3-3 3 2 4-4" /><path d="M9 21h6" /></>,
  roster: <><path d="M2 9l10-5 10 5-10 5z" /><path d="M6 11v5c3 2 9 2 12 0v-5" /></>,
  room: <><rect x="2" y="4" width="20" height="13" rx="1.5" /><path d="M8 21h8M12 17v4" /><circle cx="12" cy="10.5" r="2.5" /></>,
  bolt: <path d="M13 3L5 14h6l-1 7 8-11h-6z" />,
  pause: <><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  eye: <><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
} as const satisfies Record<string, ReactNode>;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 18 }: { readonly name: IconName; readonly size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={name === "check" || name === "spark" || name === "lock" ? 2 : 1.7}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}
